import React, { useMemo } from 'react';

import { TRANSACTION_TYPE_MAP } from '../../constants';
import { TransactionHistorySearch } from '../../services/api/dto/Transactions';
import { TRANSACTION_TYPE } from '../../types';
import currencyFormat from '../../utils/currencyFormat';
import { getTransactionsHistoryBadge } from '../../utils/getStatusBadge';

import TransactionDetailsHeader from './transaction-details-header';

import './transaction-details.scss';

interface IProps {
  data: TransactionHistorySearch;
}

const TransactionDetails: React.FC<IProps> = ({ data }) => {
  const title = useMemo(() => {
    return TRANSACTION_TYPE_MAP[data?.type as Exclude<TRANSACTION_TYPE, null>];
  }, [data]);

  return (
    <div className="history-details">
      <TransactionDetailsHeader />
      <div className="history-details__body">
        <div className="grid-border">
          <div className="grid-border__left">
            <div className="grid-border__top">
              {/* <div className="history-details__top">
                <h2 className="text-2 history-details__title">Операция:</h2>
              </div> */}
              <div className="history-details__info">
                <p className="title-4">
                  {title} финансовых активов на сумму <br />
                  {currencyFormat(data.value)}
                </p>
                <div className="status">
                  {getTransactionsHistoryBadge(data.status, data.type, false)}
                </div>
              </div>
            </div>
            <div className="grid-border__content">
              <div className="history-details__col history-details__col-12">
                <h2 className="text-2 history-details__title">
                  Участники операции:
                </h2>
                <div className="history-details__info-body">
                  <div className="history-details__list-item">
                    <div className="history-details__item">
                      <div className="item">
                        <div className="item__title">Покупатель:</div>
                        <div className="item__text">{data.initiator}</div>
                      </div>
                    </div>
                    <div className="history-details__item">
                      <div className="item">
                        <div className="item__title">ИНН:</div>
                        <div className="item__text">{data.initiatorTin}</div>
                      </div>
                    </div>
                  </div>
                  <div className="history-details__list-item">
                    <div className="history-details__item">
                      <div className="item">
                        <div className="item__title">Поставщик:</div>
                        <div className="item__text">{data.recipient}</div>
                      </div>
                    </div>
                    <div className="history-details__item">
                      <div className="item">
                        <div className="item__title">ИНН:</div>
                        <div className="item__text">{data.recipientTin}</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*
              {data.docs && (
                <>
                  <h2 className="text-2 history-details__title">Подписанные документы:</h2>
                  <div className="history-details__list-doc">
                    <div className="history-details__item">
                      <div className="form-item">
                        <button className="btn btn--sm btn--outline" type="button">
                          <svg className="icon 24_Icon_document_text ">
                          </svg><span className="btn__text">Спецификация.pdf, 1.2 mb</span>
                          <svg className="icon 24_Icon_dwn ">
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="history-details__item">
                      <div className="form-item">
                        <button className="btn btn--sm btn--outline" type="button">
                          <svg className="icon 24_Icon_document_text ">
                          </svg><span className="btn__text">Документ.pdf, 1.2 mb</span>
                          <svg className="icon 24_Icon_dwn ">
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="history-details__item">
                      <div className="form-item">
                        <button className="btn btn--sm btn--outline" type="button">
                          <svg className="icon 24_Icon_document_text ">
                          </svg><span className="btn__text">документ.pdf, 1.2 mb</span>
                          <svg className="icon 24_Icon_dwn ">
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;
